import Vue from 'vue';
import Router from 'vue-router';
import DarkColor from './views/partials/DarkColor';

Vue.component('app-darkcolor', DarkColor);
Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
    },
    {
      path: '/discord',
      name: 'discord',
      component: () => import(/* webpackChunkName: "home" */ './views/Discord.vue')
    },
    {
      path: '/servers',
      name: 'servers',
      component: () => import(/* webpackChunkName: "servers" */ './views/Servers.vue')
    },
    {
      path: '/premium',
      name: 'premium',
      component: () => import(/* webpackChunkName: "premium" */ './views/Premium.vue')
    },
    {
      path: '/statistics',
      name: 'statistics',
      component: () => import(/* webpackChunkName: "statistics" */ './views/Statistics.vue')
    },
    {
      path: '/league',
      name: 'league',
      component: () => import(/* webpackChunkName: "league" */ './views/League.vue')
    },
    {
      path: '/finder/player',
      name: 'finderplayer',
      component: () => import(/* webpackChunkName: "finderplayer" */ './views/finder/Player.vue')
    },
    {
      path: '/finder',
      name: 'finder',
      component: () => import(/* webpackChunkName: "finder" */ './views/finder/Player.vue')
    },
    {
      path: '/finder/settings',
      name: 'findersettings',
      component: () => import(/* webpackChunkName: "findersettings" */ './views/finder/Settings.vue')
    },
    {
      path: '/auth/login',
      name: 'auth.login',
      component: () => import(/* webpackChunkName: "auth.login" */ './views/auth/Login.vue')
    },
    {
      path: '/auth/register',
      name: 'auth.register',
      component: () => import(/* webpackChunkName: "auth.register" */ './views/auth/Register.vue')
    },
    {
      path: '/auth/verify',
      name: 'auth.verify',
      component: () => import(/* webpackChunkName: "auth.verify" */ './views/auth/Verify.vue')
    },
    {
      path: '/auth/forgot',
      name: 'auth.forgot',
      component: () => import(/* webpackChunkName: "auth.forgot" */ './views/auth/Forgot.vue')
    },
    {
      path: '/auth/reset/:verification_code/:user_id',
      name: 'auth.reset',
      component: () => import(/* webpackChunkName: "auth.reset" */ './views/auth/Reset.vue')
    },
    {
      path: '/profile/:user_id',
      name: 'player.profile',
      component: () => import(/* webpackChunkName: "player.profile" */ './views/player/Profile.vue')
    },
    {
      path: '/tnc',
      name: 'tnc',
      component: () => import(/* webpackChunkName: "tnc" */ './views/tnc.vue')
    }
  ]
});
